<form class="example-form">
  <mat-form-field class="example-full-width">
    <mat-label>{{label}}</mat-label>
    <input type="text"
      aria-label="Number"
      matInput
      [formControl]="myControl"
      [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete">
      @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option">
          {{option}}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>